import React, { useState } from "react";
import AuthManager from "../../../services/dashboard/AuthManager";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function OtpVerificationModal({ email, onVerified, onClose }) {
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("sending"); // sending | sent | verifying
  const [loading, setLoading] = useState(false);
 
  const navigate = useNavigate(); // Add this at top if not already

  const sendOtp = async () => {
    setLoading(true);
    try {
      const res = await AuthManager.requestRegistrationOtp(email);
  
      if (res.responseCode === 400 && res.responseMessage.includes("registered")) {
        toast.error("Email already registered");
        onClose();
        setTimeout(() => navigate("/login"), 1500);
        return;
      }
  
      toast.success("OTP sent to your email");
      setStep("sent");
    } catch (err) {
      const msg = err?.response?.data?.responseMessage || err.message;
      toast.error(msg);
      onClose();
    } finally {
      setLoading(false);
    }
  };
  


  const verifyOtp = async () => {
    setLoading(true);
    try {
      await AuthManager.verifyRegistrationOtp(email, otp);
      toast.success("OTP verified!");
      onVerified(email); // let parent know
    } catch (err) {
      toast.error("Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    sendOtp();
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg">
        <h2 className="text-xl font-semibold mb-4">Verify your Email</h2>
        {step === "sent" ? (
          <>
            <p className="text-sm mb-2">An OTP has been sent to <strong>{email}</strong>.</p>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full border border-gray-300 rounded px-4 py-2 mb-4"
            />
            <button
              className="w-full bg-[#FF7236] text-white py-2 rounded hover:bg-[#EB5E22]"
              onClick={verifyOtp}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </>
        ) : (
          <p>Sending OTP...</p>
        )}
        <button
          className="mt-4 text-sm text-gray-500 hover:text-gray-700 underline"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
